export enum Environments {
  DEV = 'DEV',
  PROD = 'PROD',
}
